
/**
 * 商品搜索 语言枚举
 */
export enum SearchLangType {
  /** 日文 */
  JA = '1',
  /** 中文 */
  ZH = '2',
  /** 韩文 */
  KR = '3',
  /** 英文 */
  EN = '4',
}
